"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _color = _interopRequireDefault(require("color"));

require("../../resources/sass/reset.scss");

require("../../resources/fonts/Akkurat.scss");

require("../../resources/fonts/AkkuratMono.scss");

require("../../resources/fonts/MaterialIcons.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const getOverrides = () => {
  return {
    MuiInputBase: {
      root: {
        fontFamily: "Akkurat, sans-serif"
      }
    },
    MuiFilledInput: {
      root: {
        borderTopLeftRadius: "0",
        borderTopRightRadius: "0"
      }
    },
    MuiFormLabel: {
      root: {}
    },
    MuiFormHelperText: {
      root: {}
    },
    MuiButtonGroup: {
      grouped: {}
    },
    MuiButton: {
      root: {
        fontFamily: "Akkurat, sans-serif",
        fontWeight: "bold",
        textTransform: "none",
        borderRadius: 1
      },
      outlined: {}
    }
  };
};

const getColor = (color = "#666") => {
  return (0, _color.default)(color).hex();
};

const getPalette = ({
  primaryColor,
  secondaryColor
}) => {
  return {
    primary: {
      main: getColor(primaryColor)
    },
    secondary: {
      main: getColor(secondaryColor || primaryColor)
    }
  };
};

const getTheme = (_ref) => {
  let palette = _ref.palette,
      theme = _objectWithoutPropertiesLoose(_ref, ["palette"]);

  return (0, _styles.createMuiTheme)({
    typography: {
      fontFamily: "Akkurat, sans-serif !important"
    },
    palette: palette || getPalette(theme),
    overrides: getOverrides(theme)
  });
};

const AppTheme = (_ref2) => {
  let children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, ["children"]);

  const theme = getTheme(props.theme || {});
  return _react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, children);
};

var _default = AppTheme;
exports.default = _default;
module.exports = exports.default;